import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';

import pick from 'lodash/pick';
import { SessionStorage } from 'src/app/services/session-storage.service';

import { format, addMonths, isBefore, isAfter } from 'date-fns'

import {register} from 'swiper/element/bundle';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
register();

import { Swiper, SwiperOptions }  from 'swiper/types';
import { NgxMaskDirective } from 'ngx-mask';
import { FontAwesomeModule, IconDefinition } from '@fortawesome/angular-fontawesome';
import { NgSelectComponent, NgLabelTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { CurrencyPipe, JsonPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { AudioComponent } from '../audio/audio.component';
import { VideoRecorderComponent } from 'src/app/components/video-recorder/video-recorder.component';

@Component({
    selector: 'app-voucher',
    templateUrl: './voucher.component.html',
    styleUrls: ['./voucher.component.sass'],
    imports: [FormsModule, ReactiveFormsModule, NgxMaskDirective, FontAwesomeModule, NgSelectComponent, NgLabelTemplateDirective, NgOptionTemplateDirective, CurrencyPipe, TranslatePipe, AudioComponent, VideoRecorderComponent, JsonPipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class VoucherComponent implements OnInit, OnDestroy {
    @Output() deleted: EventEmitter<void> = new EventEmitter();

    @Input() form: UntypedFormGroup;
    @Input() vouchers: UntypedFormArray;
    @Input() company: any;
    @Input() index: number;
    @Input() currency = 'USD';
    @Input() currencySymbol = '$';
    @Input() brandId: string = '';
    @Input() promocode: string = '';

    public faTimes: IconDefinition = faTimes;
    public faChevronLeft: IconDefinition = faChevronLeft;
    public faChevronRight: IconDefinition = faChevronRight;

    public directories: any;
    public expiry = format(addMonths(new Date(), 12),'MMM. do yyyy');
    public swiperIndex = 0;
    public maxIndex = 0;
    public wrapOptions: any[] = [];
    public mailServices: any[] = [];
    public hint = '';

    public filteredImages: any[] = [];
    public imageHistory: {[key:string]:string} = {};


    public initial_activity : any = 0;
    public product_id_activity : any = 0;

    public msgType: any[] = [];
    public actInfo: any[] = [];

    public wallet_img_gr: string = '';

    private formChangeSub: Subscription;

    constructor(
        private sessionStorage: SessionStorage
    ) { }

    ngOnInit() {
        this.directories = JSON.parse(this.sessionStorage.getItem('directories'))
        //console.log(this.directories);

        this.wallet_img_gr = `${this.directories.resources.images_path}/images/rezbot/600by450/54740.png`;

        let valid = this.company?.voucher_valid || 12
        if(this.currency == 'AUD' && this.company.voucher_valid < 36 ) this.company.voucher_valid = 36

        this.expiry = format(addMonths(new Date(), valid ),'MMM. do yyyy');

        let today = new Date().toISOString().replace('T',' ').substring(0,19);

        let wrapOptions = this.directories.wrap_options.
        filter(item=>(!item?.date_from || item?.date_from <= today) && (!item?.date_to || item?.date_to >= today)).
        filter(item=>(!this.brandId || !item?.brand_ids || item?.brand_ids.length == 0 || item?.brand_ids.find(brand=>brand==this.brandId)?.length>0)).
        map(item => ({ ...item, price: +item.price }));

        let mailServices = this.directories.mail_services.
        filter(item=>(!item?.date_from || item?.date_from <= today) && (!item?.date_to || item?.date_to >= today)).
        map(item => ({ ...item, price: +item.price }));

        this.mailServices = mailServices.filter(item =>
            (item.currency === null || item.currency == this.currency) && (item.tag !== 'email' && item.tag !== 'collection')
        ).sort((a, b) => {
            if (a.price > b.price) return 1;
            if (a.price < b.price) return -1;
            return 0;
        });

        let _currency = this.currency;
        this.wrapOptions = wrapOptions.filter(item => 
            (item.currency === null || item.currency == this.currency) && (item.tag === 'email' || this.mailServices.length > 0)
        ).sort((a, b) => {
            if (a.price > b.price) return 1;
            if (a.price < b.price) return -1;

            return 0;
        });
        

        let woptions:{[key:string]:any} = {};
        let moptions:{[key:string]:any} = {};
        this.wrapOptions.forEach(it=>{
            let key = it.tag;
            if(woptions[key] === undefined || +woptions[key].price > +it.price) woptions[key] = it;
        })
        this.wrapOptions = [...Object.values(woptions)];

        this.mailServices.forEach(it=>{
            let key = it.tag;
            if(moptions[key] === undefined || +moptions[key].price > +it.price) moptions[key] = it;
        })
        this.mailServices = [...Object.values(moptions)];

        if (this.company?.voucher_config?.presets?.length) {
            this.maxIndex = Math.floor(this.company.voucher_config.presets.length / 3);
        }

        if(this.wrapOptions.length==1){
            this.setWrapOption(this.wrapOptions[0]);
            this.filterImages(this.wrapOptions[0].tag);
        }else if(this.form.get('wrap_option_id').value){
            let wopt = this.wrapOptions.filter(it=>it.wrap_option_id == this.form.get('wrap_option_id').value);
            if(wopt.length > 0)
            this.setWrapOption(wopt[0]);
            this.filterImages(wopt[0].tag);
        }else {
            this.filterImages('email'); //should do it based on the wrap option
        }


        //get activity_id
        const activityId = this.parseProductID();
        //this.getActivityID();
        // Set default value for dropdown
        //watch for form changes and update image url



        if(this.company.company_id == '2'){
            this.formChangeSub = this.form.get('change_act').valueChanges.subscribe((newActivityId: number) => {
                //this.filterImages('email');
                this.product_id_activity = newActivityId;
                this.setProductID();

                let img = this.filteredImages.filter(it=>""+it.activity_id == ""+newActivityId);
                //console.log(newActivityId, img);
                if(img.length > 0){
                    const url = img[0]?.full_url;
                    this.form.get('image').setValue(url);
                    this.form.get('design').setValue(url);
                }else if (newActivityId > 0) {
                    //const url = `${this.directories.resources.images_path}/images/geronigo_new/activities/${newActivityId}/webp/hero-small.webp`;
                    const url = this.filteredImages[0]?.full_url; //default image
                    this.form.get('image').setValue(url);
                    this.form.get('design').setValue(url);
                } else if (newActivityId == 0) {
                    const url = this.filteredImages[0]?.full_url;
                    //const url = `${this.directories.resources.images_path}/images/rezbot/600by450/54740.png`;
                    this.form.get('image').setValue(url);
                    this.form.get('design').setValue(url);
                } else {
                    this.form.get('image').setValue('');
                    this.form.get('design').setValue('');
                }
            });


        this.form.get('change_act')?.setValue(activityId);

            if(!this.form.get('image').value){
                this.form.get('change_act').setValue(activityId);
            }
        }

        this.msgType = [
            { text: 'Audio message', value: 'audio' },
            { text: 'Video message', value: 'video' },
            { text: 'No audio or video message', value: '' }
        ];
        this.actInfo = [
            {activity_id:'0', name:'Every Adventure'},
            ...this.directories.activities
        ];
        //console.log(this.directories.activities);

        //Initconsole.log(this.actInfo);
        
        this.setHistory();
        setTimeout(() => this.checkHint());
    }

    ngOnDestroy() {
        if (this.formChangeSub) this.formChangeSub.unsubscribe();
    }

    public setHistory(){
        let wos = this.wrapOptions.filter(it=>this.form.get('wrap_option_id').value == it.wrap_option_id);
        if(wos[0]){
            this.imageHistory[wos[0].tag] = this.form.get('design').value;
        }
    }

    

    public onImageError(event: Event){
        const img = event.target as HTMLImageElement;

        const placeholderUrl = `${this.directories.resources.images_path}/images/rezbot/600by450/54740.png`;

        if (img.src !== placeholderUrl) {
        img.src = placeholderUrl;
        } else {
            // Optionally, log a warning if the placeholder is missing
            console.warn('Placeholder image is missing:', placeholderUrl);
        }
        
    }

    public getActivityID(){
        /*const product_id = this.form.get('product_id').value;
        const activityIdMatch = /A(\d+)/.exec(product_id);
        const activityId = activityIdMatch ? activityIdMatch[1] : null;
        return activityId;*/
        return this.parseProductID();
    }

    public parseProductID(){
        if(!this.form.get('product_id').value) return;
        const regex = /(?:GV(?<VALUE>\d+)|V(?<VENUE>\d+)|GP(?<PRESET>\d+)|GE(?<EXP>\d+)[A-Za-z]?)(?:A(?<ACT>\d+))?(?:C(?<CAT>\d+))?(?:P(?<PKG>\d+)|(?<CURR>\w+)|$)/i;
        const match = regex.exec(this.form.get('product_id').value);

    if (match && match.groups) {
        // Example: You can access match.groups.VALUE, match.groups.VENUE, etc.
        // Assign parsed values to component properties if needed
        // For demonstration, let's log them:
        this.initial_activity = match.groups.ACT;


        // Optionally, store parsed values in the component
        // this.parsedProductId = match.groups;
    }
        return this.initial_activity;
    }

    public setProductID(){
        let value = Math.round(this.form.get('value').value);

        let activity = this.initial_activity ?? 0;
        if(this.product_id_activity) activity = this.product_id_activity;
        
        let product_id = `GV${value}A${activity}${this.currency}`;
        this.form.get('product_id').setValue(product_id);
    }

    public setImage(item){
        let value = this.form.get('value').value;

        if(item?.activity_id){
            this.product_id_activity = item.activity_id;
        }else{
            this.product_id_activity = this.initial_activity ?? 0;
        }
        this.setProductID();
        this.form.get('design').setValue(item?.full_url);
        this.form.get('image').setValue(item?.full_url); 

        this.setHistory();
    }

    public changePath() {
        if(!this.company?.logo) return;
        if (this.company?.logo.startsWith('https://rezbot.net')) return;

        const { resources } = this.directories;

        this.company.logo = this.company.logo.replace(resources.images_path, resources.fallback_path);
    }

    public setPreset(item: any): void {
        this.form.get('preset').setValue(item);
        this.form.get('value').setValue(item.price);
    }

    public setWrapOption(item: any): void {
        let func = 'enable';

        if(this.wrapOptions.length == 1){
            item.tag = this.wrapOptions[0].tag
        }

        const value :any= {
            mail_service_id: '',
            tag: item.tag,
            image: item.image
        };

        if (item.tag === 'email') {
            const mail = this.directories.mail_services.find(val => val.tag === 'email');

            value.mail_service_id = mail.mail_service_id;

            func = 'disable';
        } else {
            value.mail_service_id = this.mailServices[0].mail_service_id;
        }

        let voucher = this.vouchers.at(this.index).value;

        if(!voucher?.preset && !voucher.fixed_image){
            this.filterImages(item.tag);

            let found = this.filteredImages.filter(img=>this.imageHistory[item.tag] == img?.full_url)
            let url = this.filteredImages?.[0]?.full_url



            if(found.length > 0) url = found?.[0]?.full_url;
            value.design = url;
            value.image = url;
        }

        

        ['delivery_name','address_1', 'address_2', 'town', 'zip'].forEach(val => this.form.get(val)[func]());

        this.form.patchValue(value);
        this.setHistory();
    }

    public filterImages(tag:string){
        
        //const activityId = this.getActivityID();

        let images = this.company.images;
        images = images.filter(it=> it.brand_id == this.brandId);
        if(images.length == 0){
            console.log('no images for brand, get all', this.company.images);
            images = this.company.images;
        }
        
        if(true /*this.brandId != '4696'*/){
            this.filteredImages = images.filter(it=>it.caption==`wrap_option:${this.company.company_id}:${tag}`)
            if(this.filteredImages.length == 0){
                this.filteredImages = images.filter(it=>it.caption==`wrap_option:${this.company.company_id}:email`)
            }
            if(this.filteredImages.length == 0){
                this.filteredImages = images;
            }
        }
        this.parseProductID()

        if(this.brandId == '4696'){

            let unknown = [];

            let actImages : { [key: string]: any } = {};

            const url = `${this.directories.resources.images_path}/images/rezbot/600by450/54740.png`;
            let default_img = {activity_id:0, full_url:url};
            this.directories.activities.forEach((act)=>{
                let activityId = act.activity_id;
                if(activityId  && activityId != '0'){
                    let filts = this.filteredImages.filter(it=>it.activity_id == activityId);
                    if(filts.length > 0){
                        if(!actImages[activityId]){
                            actImages[activityId] = filts[0];
                        }
                    }else{
                        actImages[activityId] = {...default_img, activity_id:activityId};
                        unknown.push(activityId);
                    }
                } else {
                    actImages[activityId] = {...default_img, activity_id:activityId};
                }
            });
            this.filteredImages = Object.values(actImages);
            //if(unknown.length > 0) console.log(unknown);
        }
        
        this.setProductID();
    }

    public getActNameById(id: string): string {
        const actName = this.actInfo?.find(a => a.activity_id === id);
        return actName ? actName.name : '';
    }

    public editVoucherValue(value: number): void {
        const control = this.form.get('value');

        if(this.currency == 'ZAR' && this.company?.company_id == '2'){
            value = value*20;
        }

        const val = control.value + value;

        if (val <= this.company?.voucher_config?.max && val >= this.company?.voucher_config?.min) control.setValue(val);

        this.setProductID();
        this.checkHint();
    }

    public copyAddress(): void {
        const addressField = ['delivery_name','address_1', 'address_2', 'town', 'zip'];
        const voucher = this.vouchers.at(this.index - 1).value;

        this.form.patchValue(pick(voucher, addressField));
    }

    private checkHint(): void {
        if (!this.company?.voucher_config || !this.company?.voucher_config?.hints) return;

        const hint = this.company?.voucher_config?.hints.find(item => item.val === this.form.get('value').value);

        if (hint) this.hint = hint.text;
        else this.hint = '';
    }

    public needsLogo(string: string){
        let parts = string.split('/');
        return +(parts[parts.length-1].split('.')[0]) > 54700 || string.endsWith('hero-small.webp');;
    }
/*
    public recordAudio(el){
        console.log(el);
        this.vouchers.at(this.index).get('audio').setValue(el.blob);
    }*/

    //onAudioRecorded(event: { blob: string; duration: number; size: number }) {
    onRecorded(event) {
        // Update the form with the emitted audio data
        this.vouchers.at(this.index).patchValue({
            audio_video: event
        });
    }
}
